import { motion } from "framer-motion";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const TextPage = ({ eyebrow, title, note, children, testId }) => (
  <div data-testid={testId}>
    <Header />
    <main className="max-w-3xl mx-auto px-6 py-20 sm:py-28">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-brass mb-4">
          {eyebrow}
        </p>
        {title && (
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-charcoal">
            {title}
          </h1>
        )}
        {note && (
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-charcoal/50">
            {note}
          </p>
        )}
        <div className="mt-12 space-y-10">{children}</div>
      </motion.div>
    </main>
    <Footer />
  </div>
);

export const TextSection = ({ title, children, testId }) => (
  <section data-testid={testId} className="border-t hairline pt-8">
    {title && (
      <h2 className="font-serif text-2xl tracking-tight text-charcoal mb-4">
        {title}
      </h2>
    )}
    <div className="text-sm sm:text-base leading-relaxed text-charcoal/80 space-y-4">
      {children}
    </div>
  </section>
);
